import React from 'react';
import "./Footer.css";

const Footer = () => {
  return (
    <div className='container-footer'>
      
    </div>
  )
}

export default Footer
